var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.915 4.05126C16.925 4.45326 17.234 5.85326 17.647 6.30326C18.06 6.75326 18.651 6.90626 18.978 6.90626C20.716 6.90626 22.125 8.31526 22.125 10.0523V15.8473C22.125 18.1773 20.235 20.0673 17.905 20.0673H7.845C5.514 20.0673 3.625 18.1773 3.625 15.8473V10.0523C3.625 8.31526 5.034 6.90626 6.772 6.90626C7.098 6.90626 7.689 6.75326 8.103 6.30326C8.516 5.85326 8.824 4.45326 9.834 4.05126C10.845 3.64926 14.905 3.64926 15.915 4.05126Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3705 9.5H18.3795",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0533 13.128C16.0533 11.372 14.6303 9.94897 12.8743 9.94897C11.1183 9.94897 9.69531 11.372 9.69531 13.128C9.69531 14.884 11.1183 16.307 12.8743 16.307C14.6303 16.307 16.0533 14.884 16.0533 13.128Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCameraIcon);
export default __webpack_public_path__ + "static/media/home-camera-icon.16ae55f188b43ab1ef8d14165e556158.svg";
export { ForwardRef as ReactComponent };